import React from "react";
import {
  makeStyles,
  Box,
  Container,
  Grid,
  Typography,
  Button,
} from "@material-ui/core";
import { AnimationOnScroll } from "react-animation-on-scroll";
const useStyles = makeStyles((theme) => ({
  roadmapYearBox: {
    position: "relative",
    zIndex: "9",
    padding: "20px 0 50px",
    [theme.breakpoints.only("xs")]: {
      marginTop: "-50px",
    },
    "& .roadcontentBox": {
      background: "rgba(255, 255, 255, 0.04)",
      borderRadius: "10px",
      padding: "20px",
      zIndex: "9999",
    },
    "& .commingBox": {
      background: "#FF4626",
      borderRadius: "10px",
      height: "36px",
      minWidth: "137px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  },
}));

const roadContent = [
  [
    {
      text: " Quarter 1",
      comming: "Coming Soon",
    },
    {
      text: " High Quality NFT Collection",
    },
    {
      text: " High Quality NFT Collection",
    },
    {
      text: " High Quality NFT Collection",
    },
  ],
  [
    {
      text: "Quarter 2",
      comming: "Coming Soon",
    },
    {
      text: "Centralized exchange: Completed",
    },
    {
      text: "NFT Marketplace: Completed",
    },
    {
      text: "P2E game (arcade and strategy-based game utilizing all NFT collections) created and sold on Generative NFT, giving them a reselling value with higher return rates  ",
    },
  ],
  [
    {
      text: "Quarter 3",
      comming: "Coming Soon",
    },
    {
      text: " DEX launch with GraphQL, token creator, staking and IDO launchpad : Dex Wallet Stablecoin ",
    },
    // {
    //   text: " High Quality NFT Collection",
    // },
    // {
    //   text: " High Quality NFT Collection",
    // },
  ],
  [
    {
      text: "Quarter 4",
      comming: "Coming Soon",
    },
    {
      text: "Dex Wallet : Metaverse virtual store platform with over 1000 templates for businesses to sell their physical items. Similar concept as https://metadrob.com/ but with stablecoin utility and NFTs to customise the stores.",
    },
  ],
  [
    {
      text: "Quarter 1",
      comming: "Coming Soon",
    },
    {
      text: "Advancements in Arcade based P2E games for implementing the next stages for recently created collections of NFT ",
    },
    {
      text: "Decentralised MLM based rewards system linked with all other applications created in the FIEREX ecosystem ",
    },

  ],
  [
    {
      text: "Quarter 2",
      comming: "Coming Soon",
    },
    {
      text: "Remittance-based application utilizing stablecoin created on FIEREX Blockchain for easing cross-border remittances",
    },
    // {
    //   text: " High Quality NFT Collection",
    // },
    // {
    //   text: " High Quality NFT Collection",
    // },
  ],
  [
    {
      text: "Quarter 3",
      comming: "Coming Soon",
    },
    {
      text: "Metaverse meeting/convention platform with VR enabling",
    },
    // {
    //   text: " High Quality NFT Collection",
    // },
    // {
    //   text: " High Quality NFT Collection",
    // },
  ],
  [
    {
      text: " Quarter 1",
      comming: "Coming Soon",
    },
    {
      text: "Website for Fierex: ",
    },
    {
      text: "White Paper launch",
    },
    {
      text: "Blockchain launch: Completed",
    },
    {
      text: "ICO platform  ",
    },
  ],
];

function RoadmapYear({ activeIndex }) {
  const classes = useStyles();
  return (
    <>
      <Box className={classes.roadmapYearBox}>
        <Container maxWidth="lg">
          <Box style={{ width: "100%" }}>
            <Grid container spacing={2} alignItems="center">
              {roadContent &&
                roadContent[activeIndex] &&
                roadContent[activeIndex]?.map((data) => {
                  return (
                    <Grid item xs={12}>
                      <Box className="roadcontentBox displaySpacebetween">
                        <AnimationOnScroll animateIn="animate__fadeInUp">
                          <Typography variant="body1" color="primary">
                            {data.text}
                          </Typography>
                        </AnimationOnScroll>
                      </Box>
                    </Grid>
                  );
                })}
            </Grid>
          </Box>
        </Container>
      </Box>
    </>
  );
}

export default RoadmapYear;
